var React = require('react');

function PlayVideo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12zm9.849 3.754l5.886-3.09a.75.75 0 000-1.328l-5.886-3.09a.75.75 0 00-1.099.665v6.178c0 .564.6.927 1.099.665z","fill":"#3D7DFF"}));
}

PlayVideo.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = PlayVideo;

PlayVideo.default = PlayVideo;
